import { call, put, takeLatest, select, all, takeEvery, fork } from "redux-saga/effects";
import { MasterAPI } from "services/master";
import { convertArrayToObject, mockResponse } from "utils/common-util";
import {
  getConstants,
  getConstantsSuccess,
  getConstantsFailure,
  //------------------
  fetchBrokerList,
  fetchBrokerListSuccess,
  fetchBrokerListFailure,
  //------------------
  fetchReceiveMethodList,
  fetchReceiveMethodListSuccess,
  fetchReceiveMethodListFailure,
  //------------------
  getSubscriptionConst,
  getSubscriptionConstSuccess,
  getSubscriptionConstFailure,
  //------------------
  searchDistrict,
  searchDistrictSuccess,
  searchDistrictFailure,
  //------------------
  searchSubDistrict,
  searchSubDistrictSuccess,
  searchSubDistrictFailure,
  getProvinceList,
  getProvinceListFailure,
  getProvinceListSuccess,

  getTitle,
  getTitleSuccess,
  getTitleFailure,
  searchCountrySuccess,
  searchCountryFailure,
  searchPwmOccupationSuccess,
  searchPwmOccupationFailure,
  searchPwmMonthlyIncomeSuccess,
  searchPwmMonthlyIncomeFailure,
  searchCountry,
  searchPwmBusinessType,
  searchPwmMonthlyIncome,
  searchPwmOccupation,
  searchPwmBusinessTypeSuccess,
  searchPwmBusinessTypeFailure,
  searchIncome,
  searchIncomeSuccess,
  searchIncomeFailure,
  getFundType,
  getFundTypeSuccess,
  getFundTypeFailure,
} from "redux/reducers/master";
import { MasterSelector } from "redux/selector";
import { AddressSelector } from "redux/selector/master-address-selector";
import { FundAPI } from "services/fund";

const getConstantsSaga = function* () {
  try {
    const response = yield call(MasterAPI.getAllConstant);
    const {
      errorMessageList,
      hideButtonRegisterPrivateWealth,
      hideFundNavigation,
      hideMenuFundTransaction,
    } = response.data;

    const constants = {
      errorConst: convertArrayToObject(errorMessageList, "errorCode"),
      hideButtonRegisterPrivateWealth,
      hideFundNavigation,
      hideMenuFundTransaction,
    }

    yield put(getConstantsSuccess(constants));
  } catch (error) {
    yield put(getConstantsFailure(error));
  }
};

const getSubscriptionConstSaga = function* () {
  try {
    const brokerList = yield select(MasterSelector.brokerList);
    const receiveMethodList = yield select(MasterSelector.receiveMethodList);
    const incomeSourceList = yield select(MasterSelector.incomeSourceList);

    const [
      brokerListResp,
      receiveMethodListResp,
      incomeSourceListResp,
    ] = yield all([
      brokerList.length === 0
        ? call(MasterAPI.getBrokerList)
        : mockResponse(brokerList),
      receiveMethodList.length === 0
        ? call(MasterAPI.getReceiveMethodList)
        : mockResponse(receiveMethodList),
      incomeSourceList.length === 0
        ? call(MasterAPI.getIncomeSource)
        : mockResponse(incomeSourceList),
    ]);

    yield fork(getProvinceListSaga)
    yield put(
      getSubscriptionConstSuccess({
        brokerList: brokerListResp.data.result,
        receiveMethodList: receiveMethodListResp.data.result,
        incomeSourceList: incomeSourceListResp.data.result,
      })
    );
  } catch (error) {
    yield put(getSubscriptionConstFailure(error));
  }
};

const fetchBrokerListSaga = function* () {
  try {
    const brokerList = yield select(MasterSelector.brokerList);
    if (!brokerList || brokerList.length === 0) {
      const response = yield call(MasterAPI.getBrokerList);
      yield put(fetchBrokerListSuccess(response.data.result));
    }
  } catch (error) {
    yield put(fetchBrokerListFailure(error));
  }
};

const fetchReceiveMethodListSaga = function* () {
  try {
    const receiveMethodList = yield select(MasterSelector.receiveMethodList);
    if (!receiveMethodList || receiveMethodList.length === 0) {
      const response = yield call(MasterAPI.getReceiveMethodList);
      yield put(fetchReceiveMethodListSuccess(response.data.result));
    }
  } catch (error) {
    yield put(fetchReceiveMethodListFailure(error));
  }
};

const searchDistrictSaga = function* (action) {
  try {
    let districtList = (yield select(AddressSelector.districtCache))[action.payload.provinceCode];
    if (!districtList) {
      districtList = yield call(getDistrictSaga, action.payload);
      yield put(searchDistrictSuccess(districtList));
    }
  } catch (error) {
    yield put(searchDistrictFailure(error.message));
  }
};

const searchSubDistrictSaga = function* (action) {
  try {
    const { provinceCode, districtCode } = action.payload;
    let subbDistrictList = (yield select(AddressSelector.subDistrictCache))[`${provinceCode}_${districtCode}`];
    if (!subbDistrictList) {
      subbDistrictList = yield call(getSubDistrictSaga, action.payload);
      yield put(searchSubDistrictSuccess(subbDistrictList));
    }
  } catch (error) {
    console.log(error)
    yield put(searchSubDistrictFailure(error));
  }
};

export const getDistrictSaga = function* (condition) {
  const response = yield call(MasterAPI.searchDistrict, { condition });
  return response.data.result ?? [];
};

export const getSubDistrictSaga = function* (condition) {
  const response = yield call(MasterAPI.searchSubDistrict, { condition });
  return response.data.result ?? [];
};

export const getProvinceText = function* (provinceCode) {
  let provinceList = yield select(AddressSelector.provinces);
  if (!provinceList) {
    provinceList = yield call(getProvinceListSaga)
  }
  return (provinceList || []).find(p => p.provinceCode === provinceCode).provinceName
}

export const getDistrictText = function* (provinceCode, districtCode) {
  const condition = {
    provinceCode: `${+provinceCode}`,
    districtCode: `${+districtCode}`,
  }
  const districtList = yield call(getDistrictSaga, condition);
  return districtList?.find(d => `${+d.districtCode}` === districtCode)?.districtName;
}

export const getSubDistrictText = function* (provinceCode, districtCode, subDistrictCode) {
  const condition = {
    provinceCode: `${+provinceCode}`,
    districtCode: `${+districtCode}`,
    subDistrictCode: subDistrictCode,
  }
  const subDistrictList = yield call(getSubDistrictSaga, condition);
  return subDistrictList?.find(sd => sd.subDistrictCode === subDistrictCode)?.subDistrictName;
}

export const getAddressCompact = function* (provinceCode, districtCode, subDistrictCode) {
  const [province, district, subDistrict] = yield all([
    call(getProvinceText, provinceCode),
    call(getDistrictText, provinceCode, districtCode),
    call(getSubDistrictText, provinceCode, districtCode, subDistrictCode),
  ])
  return [province?.trim(), district?.trim(), subDistrict?.trim()];
}

export const getProvinceListSaga = function* () {
  try {
    const provinces = yield select(AddressSelector.provinces)
    if (!provinces || provinces.length === 0) {
      const response = yield call(MasterAPI.getProvinceList)
      yield put(getProvinceListSuccess(response.data.result ?? []))
    }

    return provinces
  } catch (error) {
    yield put(getProvinceListFailure(error))
  }
}

export const getTitleSaga = function* () {
  try {
    const titleOthers = yield select(MasterSelector.titleOthers)
    if (!titleOthers || titleOthers.length === 0) {
      const response = yield call(MasterAPI.searchTitle)
      yield put(getTitleSuccess(response.data.result ?? []))
    }
  } catch (error) {
    yield put(getTitleFailure(error))
  }
}

const getCountry = function* () {
  try {
    const countrys = yield select(MasterSelector.countryList)
    if (!countrys || countrys.length === 0) {
      const response = yield call(MasterAPI.searchCountry)
      yield put(searchCountrySuccess(response.data.result ?? []))
    }
  } catch (error) {
    yield put(searchCountryFailure(error))
  }
};

const getPwmOccupation = function* () {
  try {
    const pwmOccupations = yield select(MasterSelector.pwmOccupationList)
    if (!pwmOccupations || pwmOccupations.length === 0) {
      const response = yield call(MasterAPI.searchPwmOccupation)
      yield put(searchPwmOccupationSuccess(response.data.result ?? []))
    }
  } catch (error) {
    yield put(searchPwmOccupationFailure(error))
  }
}

const getPwmBusinessType = function* () {
  try {
    const pwmBusinessTypes = yield select(MasterSelector.pwmBusinessTypeList)
    if (!pwmBusinessTypes || pwmBusinessTypes.length === 0) {
      const response = yield call(MasterAPI.searchPwmBusinessType)
      yield put(searchPwmBusinessTypeSuccess(response.data.result ?? []))
    }
  } catch (error) {
    yield put(searchPwmBusinessTypeFailure(error))
  }
}

const getPwmMonthlyIncome = function* () {
  try {
    const pwmMonthlyIncomes = yield select(MasterSelector.pwmMonthlyIncomeList)
    if (!pwmMonthlyIncomes || pwmMonthlyIncomes.length === 0) {
      const response = yield call(MasterAPI.searchPwmMonthlyIncome)
      yield put(searchPwmMonthlyIncomeSuccess(response.data.result ?? []))
    }
  } catch (error) {
    yield put(searchPwmMonthlyIncomeFailure(error))
  }
}

const getIncomeSource = function* () {
  try {
    const pwmIncomes = yield select(MasterSelector.incomeSourceList)
    if (!pwmIncomes || pwmIncomes.length === 0) {
      const response = yield call(MasterAPI.getIncomeSource)
      yield put(searchIncomeSuccess(response.data.result ?? []))
    }
  } catch (error) {
    yield put(searchIncomeFailure(error))
  }

}

const getFundTypeSaga = function* () {
  try {
    const listOfFundSubType = yield select(MasterSelector.listOfFundSubType)
    const listOfFundDividend = yield select(MasterSelector.listOfFundDividend)
    const listOfFundIssuer = yield select(MasterSelector.listOfFundIssuer)

    if (!listOfFundSubType || listOfFundSubType.length === 0
      || !listOfFundDividend || listOfFundDividend.length === 0
      || !listOfFundIssuer || listOfFundIssuer.lenght === 0) {
      const response = yield call(FundAPI.getFundType);
      yield put(getFundTypeSuccess(response.data ?? []))
    }
  } catch (error) {
    yield put(getFundTypeFailure(error))
  }
}

const saga = [
  takeLatest(getConstants.type, getConstantsSaga),
  takeLatest(fetchBrokerList.type, fetchBrokerListSaga),
  takeLatest(fetchReceiveMethodList.type, fetchReceiveMethodListSaga),
  takeLatest(getProvinceList.type, getProvinceListSaga),
  takeLatest(getSubscriptionConst.type, getSubscriptionConstSaga),
  takeEvery(searchDistrict.type, searchDistrictSaga),
  takeEvery(searchSubDistrict.type, searchSubDistrictSaga),
  takeEvery(getTitle.type, getTitleSaga),
  takeLatest(searchCountry.type, getCountry),
  takeLatest(searchPwmOccupation.type, getPwmOccupation),
  takeLatest(searchPwmBusinessType.type, getPwmBusinessType),
  takeLatest(searchPwmMonthlyIncome.type, getPwmMonthlyIncome),
  takeLatest(searchIncome.type, getIncomeSource),
  takeLatest(getFundType.type, getFundTypeSaga),
];

export default saga;
